import axios from "axios";

import authHeader from "./auth/auth-header";

const baseUrl = process.env.REACT_APP_API_URL;

/**
 * Recupera lista de años para consultar estados de cuenta
 * @param {String} an8 - an8 del cliente
 * @returns {any} recupera la respuesta de la solicitud
 * @author alSanchez - ETE
 * @version 1.0.0 - Enero 2024
 */
const getYears = async (an8) => {

  const token = await authHeader();

  return axios.get( `${baseUrl}/date/year-account/${an8}`,
   { headers: token }
   ).then(
    (response) => {
      return response.data;
    });
};
/**
 * Recuperar lista de meses para consultar estados de cuenta
 * @param an8 {String} - an8 del cliente
 * @param year {String} - mes solicitado
 * @returns {Array} recupera un array de las solicitudes disponibles
 * @author Kenzo Sashida - ETE
 * @version 2.0.0 -Noviembre 2024
 */
const getMonths = async (an8, year) =>{
    const token =  await authHeader();
    return  axios.get( `${baseUrl}/date/month-account/${year}/${an8}`,{
        headers: token
    }).then(
        (response) => {
            return response.data;
        }
    )
}
const downloadBillingStatement = async (data) => {

    console.log(data,"This is from the service");

    const url = `${ baseUrl }/account-status/pdf-xml`;
    const token = await authHeader();

    return axios
    .get(url,{
      params: data,
      headers: token 
    },
    {
      responseType: 'blob'
    }
    )
    .then(response => {
      return response.data;
      }
      )
  };

export default {
    getYears,
    getMonths,
    downloadBillingStatement
};